import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../config";
import "./AddDepartment.css";

function AddDepartment() {
  const [deptName, setDeptName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!deptName.trim()) {
      setError("Department name cannot be empty.");
      return;
    }
    setError("");
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${API_URL}/api/addDepartment`,
        { deptName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(res.data.message);
      navigate("/admin/department");
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message);
      } else {
        setError("Something went wrong!");
      }
    }
  };

  return (
    <div className="container mt-4 add-department-page">
      <div className="add-department-shell">
        <button
          className="btn btn-outline-secondary mb-3"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
        <div className="card add-department-card shadow-sm">
          <div className="card-header add-department-header">
            <h4 className="mb-0">Add New Department</h4>
          </div>

          <div className="card-body add-department-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label fw-semibold">Department Name</label>
                <input
                  type="text"
                  value={deptName}
                  onChange={(e) => setDeptName(e.target.value)}
                  placeholder="Enter Department Name"
                  className="form-control add-department-input"
                  required
                />

                {error && <div className="add-department-error">{error}</div>}
              </div>

              <button type="submit" className="btn add-department-submit w-100 fw-bold">
                Add Department
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddDepartment;
